module.exports = __webpack_public_path__ + "img/Logout Icon - white.231cad83.svg";